export const getStaffTimeAmount = (qty, rate, time) => {
  return qty * rate + time * 5;
};

export const getMileageAmount = (qty, rate) => {
  return qty * rate;
};
